import { BuiltCampaignControllerTrigger } from "./BuiltCampaignControllerTrigger";
export const isBuiltCampaignControllerTriggerHasPriorStep = (trigger) => trigger instanceof BuiltCampaignControllerTriggerHasPriorStep;
export class BuiltCampaignControllerTriggerHasPriorStep extends BuiltCampaignControllerTrigger {
    constructor(response, context) {
        super(response, context);
        this.filterNames = response.filter_names;
        this.filterScope = response.filter_scope;
        this.filterPartnerEventIdName = response.filter_partner_event_id_name;
        this.filterPartnerEventIdValue = response.filter_partner_event_id_value;
        this.filterPartnerEventId = response.filter_partner_event_id;
        this.filterMinAge = response.filter_min_age;
        this.filterMaxAge = response.filter_max_age;
        this.filterMinValue = response.filter_min_value;
        this.filterMaxValue = response.filter_max_value;
        this.filterQuality = response.filter_quality;
        this.filterExpressions = response.filter_expressions;
        this.filterExpression = response.filter_expression;
        this.filterProgramLabel = response.filter_program_label;
        this.filterCampaignId = response.filter_campaign_id;
        this.filterProgramLabels = response.filter_program_labels;
        this.filterCampaignIds = response.filter_campaign_ids;
        this.filterMinDate = response.filter_min_date;
        this.filterMaxDate = response.filter_max_date;
        this.sumOfValueMin = response.sum_of_value_min;
        this.sumOfValueMax = response.sum_of_value_max;
        this.countMin = response.count_min;
        this.countMax = response.count_max;
        this.countMatches = response.count_matches;
        this.personId = response.person_id;
    }
}
